import React from 'react';
import { doAllIssuesHaveSameHowToFixLink } from '../../helpers/issuesHelper';
import { buildHowToFixLink } from '../../helpers/buildHowToFixLink';

export const renderIssueTitle = (errorMessage, issues) => {
  const globalHowToFixIcon = getGlobalHowToFixIcon(issues);
  return (
    <h5>
      {globalHowToFixIcon} {errorMessage}
    </h5>
  );
};

export const renderIssuesContent = (nodes, issues, elementName) => {
  if (!nodes.length) {
    const message = elementName
      ? `${elementName} has missing or wrong data - check for potential issues in the top summary.`
      : 'There is missing or wrong data - check for potential issues in the top summary';
    return <>{message}</>;
  }

  if (issues.length) {
    return renderIssues(issues);
  }

  return <></>;
};

const renderIssues = (issues) => {
  const renderHowToFixIcon = !doAllIssuesHaveSameHowToFixLink(issues);
  return issues.map((issue, index) => renderIssue(issue, index, renderHowToFixIcon));
};

const renderIssue = (issue, index, renderHowToFixIcon) => {
  const { whereToFixLink } = issue;

  if (whereToFixLink) {
    return renderIssueWithWhereToFixLink(issue, index, renderHowToFixIcon);
  }

  return renderIssueWithoutWhereToFixLink(issue, renderHowToFixIcon);
};

const renderIssueWithWhereToFixLink = (issue, index, renderHowToFixIcon) => {
  const { whereToFixLink, howToFixLink, message } = issue;
  return (
    <p key={index}>
      <a href={whereToFixLink} title="This is a link to where the issue can be fixed." target="_blank">
        {renderHowToFixIcon && howToFixLink && buildHowToFixLink(howToFixLink)}
        {message}
      </a>
    </p>
  );
};
const renderIssueWithoutWhereToFixLink = (issue, index, renderHowToFixIcon) => {
  const { howToFixLink, message } = issue;
  return (
    <p key={index}>
      {renderHowToFixIcon && howToFixLink && buildHowToFixLink(howToFixLink)}
      {message}
    </p>
  );
};
function getGlobalHowToFixIcon(issues) {
  let globalHowToFixIcon = undefined;
  if (doAllIssuesHaveSameHowToFixLink(issues)) {
    globalHowToFixIcon = buildHowToFixLink(issues[0].howToFixLink);
  }
  return globalHowToFixIcon;
}
